import numeral from 'numeral';
import 'numeral/locales';

// remeber to set locale before using formatters
export const setLocale = (locale) => {
  let numeralLocale = locale;
  if (locale === 'fr-FR') {
    numeralLocale = 'fr';
  } else if (locale === 'da') {
    numeralLocale = 'da-dk';
  } else if (locale === 'sv') {
    // There is a pull request for this in numeral. This code is a copy from pull request
    // TODO: remove this when sv is added to numeral.
    if (!numeral.locales.sv) {
      numeral.register('locale', 'sv', {
      delimiters: {
        thousands: ' ',
        decimal: ','
      },
      abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'md',
        trillion: 'bn'
      },
      ordinal: function (number) {
        var b = number % 10;
        return ~~(number % 100 / 10) === 1 ? ':a' : b === 1 ? ':a' : b === 2 ? ':a' : b === 3 ? ':e' : ':e';
      },
      currency: {
        symbol: 'SKR'
      }
    });
    }
  }
  numeral.locale(numeralLocale);
}

export const formatAmount = (amount) => {
  if (amount == null) {
    return "-";
  }
  const number = numeral(amount);
  return number.format('0,0');
}

export const formatWith2Decimals = (amount) => {
  if (amount == null) {
    return "-";
  }
  const number = numeral(amount);
  return number.format('0.00');
}

export const formatCurrency = (amount, currency) => {
  if (amount == null) {
    return "-";
  }
  const number = numeral(amount);
  return number.format('0,0') + ' ' + currency;
}

export const formatPercent = (amount, decimals = 2) => {
  if (amount == null) {
    return "-";
  }
  const number = numeral(amount);
  const format = `0.${'0'.repeat(decimals)} %`;
  return number.divide(100).format(format);
}
